<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { authComputed, authMethods } from "@/state/helpers";
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import Middleware from "@/helpers/middlewares";

// Custom Components
import AdditionalFields from "@/components/hotel/additionalFields.vue";
import errorHandler from "@/helpers/errorHandler";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  page: {
    title: "Hotel",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    Multiselect,
    AdditionalFields,
  },
  data() {
    return {
      title: "Additional Field",
      additionalFieldsData: [],
      openAdditionalFieldDrawer: false,
      selectedField: null,
      isEdit: false,
      sectionLabelOptions: [],
      is_btn_loading: false,
    };
  },
  computed: {
    ...authComputed,
    addFieldProps() {
      return {
        selectedField: this.selectedField,
        isEdit: this.isEdit,
        sectionLabelOptions: this.sectionLabelOptions,
      };
    },
  },
  mounted() {
    this.getAdditionalData();
  },
  methods: {
    ...authMethods,
    // Method is use for get additional filed
    async getAdditionalData() {
      try {
        const response = await hotelService.getHotelDetails();
        if (response.booking_additional_field !== undefined || null) {
          this.maintainedData(response.booking_additional_field);
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for open and close drawer
    additionFiledForm() {
      if (this.openAdditionalFieldDrawer == true) {
        this.selectedField = null;
        this.isEdit = false;
      }
      this.openAdditionalFieldDrawer = !this.openAdditionalFieldDrawer;
    },
    // Method is use for save and add new additional fields
    saveAndAddNewAdditionField(data) {
      Middleware.notification("Successfully created !!", "success");

      this.maintainedData(data);
    },
    // Method is use for add new additional field
    addNewAdditionalField(isEdit, data) {
      if (isEdit) {
        Middleware.notification("Successfully updated !!", "info");
      } else {
        Middleware.notification("Successfully created !!", "info");
      }
      this.maintainedData(data);
      this.additionFiledForm();
    },
    // Method is use for set additional data
    editAdditionalField(data) {
      this.selectedField = data;
      this.isEdit = true;
      this.additionFiledForm();
    },
    // Method is use for remove additional field
    deleteAdditionalField(data, index) {
      Swal.fire({
        title: "Are you sure you want to delete this element?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          let mainIndex = null;
          this.additionalFieldsData = this.additionalFieldsData.map(
            (item, mIndex) => {
              if (item.key == data.section_text) {
                item.value.splice(index, 1);
                if (item.value.length == 0) {
                  mainIndex = mIndex;
                }
              }
              return item;
            }
          );
          if (mainIndex !== null) {
            this.additionalFieldsData.splice(mainIndex, 1);
          }
          Middleware.notification("Successfully deleted !!", "danger");
        }
      });
    },
    // maintained additional filed data
    maintainedData(data) {
      // For maintained array of additional field
      if (Array.isArray(data)) {
        data.map((item) => {
          this.additionalFieldsData.push({ key: item.key, value: item.value });
          this.sectionLabelOptions.push({ text: item.key, value: item.key });
        });
      }
      // For maintained object of new added additional field
      else {
        delete data.sectionLabelOption;
        if (this.additionalFieldsData.length !== 0) {
          this.additionalFieldsData = this.additionalFieldsData.map((item) => {
            item.value = item.value.filter(
              (vItem) => vItem.field_text != data.field_text
            );
            return item;
          });
        }

        if (data.select_section == "ans") {
          let valueArr = [];
          data = { ...data, select_section: data.section_text };
          valueArr.push(data);
          this.additionalFieldsData.push({
            key: data.section_text,
            value: valueArr,
          });
          this.sectionLabelOptions.push({
            text: data.section_text,
            value: data.section_text,
          });
        } else {
          this.additionalFieldsData = this.additionalFieldsData.map((item) => {
            item.value = item.value.filter(
              (vItem) => vItem.field_text != data.field_text
            );
            if (
              item.key.trim().toLowerCase() ==
              data.select_section.trim().toLowerCase()
            ) {
              item.value.push(data);
            }
            return item;
          });
        }
      }
    },
    // Method is use for final save data in hotel
    async onSubmit() {
      try {
        this.is_btn_loading = true;
        let hotelData = new FormData();
        hotelData.append(
          "booking_additional_field",
          JSON.stringify(this.additionalFieldsData)
        );
        const response = await hotelService.updateHotelDetails(hotelData);
        if (response !== undefined || response !== null) {
          this.additionalFieldsData = response.booking_additional_field;
          this.sectionLabelOptions = [];
          response.booking_additional_field.map((item) => {
            this.sectionLabelOptions.push({ text: item.key, value: item.key });
          });
          this.is_btn_loading = false;
        }
        this.setHotel();
        Middleware.notification("Successfully saved !!", "success");
      } catch (error) {
        this.is_btn_loading = false;
        errorHandler(error);
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="additionFiledForm"
      text="Add New Field"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <b-card-header header-tag="header" role="tab">
            <h6 class="text-danger">
              Note :- Please Save changes to apply effect in hotel.
            </h6>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <div v-if="additionalFieldsData.length == 0">
                <div class="text-center">
                  <img
                    src="@/assets/images/empty.svg"
                    class="img-fluid"
                    alt=""
                  />
                  <p>
                    <span class="text-secondary">No Data Found</span>
                  </p>
                </div>
              </div>
              <div class="row" v-else>
                <div
                  class="col-lg-4 col-md-12"
                  v-for="data in additionalFieldsData"
                  :key="data.key"
                >
                  <b-card header-class="bg-transparent cursor-move">
                    <h5
                      class="d-flex justify-content-center align-items-center mb-2"
                    >
                      {{ data.key }}
                    </h5>
                    <hr />
                    <div class="row">
                      <div
                        class="col-md-6 mb-2"
                        v-for="(addField, index) in data.value"
                        :key="index"
                      >
                        <b-card-text>
                          <h5 class="card-title mt-0">
                            {{ index + 1 }}.
                            {{ addField.field_text }}
                            <span class="text-end float-end">
                              <a
                                :id="String(index)"
                                href="javascript:void(0)"
                                v-b-popover.hover.top="'Edit Field.'"
                                @click="editAdditionalField(addField)"
                                ><i class="fas fa-pencil-alt text-success"></i
                              ></a>
                              <a
                                :id="String(index)"
                                href="javascript:void(0)"
                                v-b-popover.hover.top="'Delete Field.'"
                                @click="deleteAdditionalField(addField, index)"
                                ><i
                                  class="mdi mdi-trash-can fs-5 ms-2 text-danger"
                                ></i
                              ></a>
                            </span>
                          </h5>
                          <!-- Maintained textarea answer type -->
                          <div v-if="addField.answer_type == 'textarea'">
                            <textarea
                              class="form-control form-control-sm"
                              cols="5"
                              :required="addField.is_required"
                              rows="5"
                            ></textarea>
                          </div>
                          <!-- Maintained radio button answer type -->
                          <div v-else-if="addField.answer_type == 'radio'">
                            <div class="col-md-12">
                              <b-form-group>
                                <b-form-radio
                                  :id="String(index)"
                                  class="mb-2"
                                  value="a"
                                  name="selectOption"
                                  plain
                                  >Yes
                                </b-form-radio>
                                <b-form-radio
                                  :id="String(index)"
                                  name="selectOption"
                                  value="b"
                                  plain
                                  >No</b-form-radio
                                >
                              </b-form-group>
                            </div>
                          </div>
                          <!-- Maintained choice answer type -->
                          <div v-else-if="addField.answer_type == 'choice'">
                            <div
                              class="col-md-12"
                              v-for="(
                                addFieldCheckBoxOptions, index
                              ) in addField.form_data_options"
                              :key="index"
                            >
                              <b-form-checkbox
                                value="accepted"
                                unchecked-value="not_accepted"
                                class="mb-2"
                                checked
                                plain
                                >{{
                                  addFieldCheckBoxOptions.option
                                }}</b-form-checkbox
                              >
                            </div>
                          </div>
                          <!-- Maintained select answer type -->
                          <div v-else-if="addField.answer_type == 'select'">
                            <div class="col-md-12" :key="index">
                              <b-form-select
                                class="form-select"
                                id="select"
                                type="text"
                              >
                                <option
                                  v-for="(
                                    item, index
                                  ) in addField.form_data_options"
                                  :key="index"
                                  :value="item.option"
                                >
                                  {{ item.option }}
                                </option>
                              </b-form-select>
                            </div>
                          </div>
                          <!-- Maintained multi select answer type -->
                          <div
                            v-else-if="addField.answer_type == 'multi_select'"
                          >
                            <div class="col-md-12" :key="index">
                              <multiselect
                                track-by="option"
                                label="option"
                                :options="addField.form_data_options"
                                :multiple="true"
                                :show-labels="false"
                              >
                              </multiselect>
                            </div>
                          </div>
                          <!-- Maintained Other Answer types -->
                          <div v-else>
                            <div class="col-md-12">
                              <input
                                :type="addField.answer_type"
                                class="form-control form-control-sm"
                                :required="addField.is_required"
                              />
                            </div>
                          </div>
                        </b-card-text>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </b-card-text>
            <!-- save button div -->
            <div class="row mt-4">
              <div class="col-md-12">
                <b-button
                  variant="outline-primary"
                  class="float-end ms-2"
                  type="submit"
                  @click="onSubmit"
                  :class="{
                    disabled: is_btn_loading,
                  }"
                >
                  <i
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    v-if="is_btn_loading"
                  ></i>
                  Save
                </b-button>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>

    <!-- Drawer is for add and update new hotel info and services -->
    <Drawer
      @close="additionFiledForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openAdditionalFieldDrawer">
        <AdditionalFields
          :currentProps="addFieldProps"
          @submitted="addNewAdditionalField"
          @cancelSubmit="additionFiledForm"
          @saveAndAddNew="saveAndAddNewAdditionField"
        />
      </div>
    </Drawer>
  </div>
</template>
<!-- 
        // let groupData = data.reduce((r, a) => {
        //   r[a.section_text] = [...(r[a.section_text] || []), a];
        //   return r;
        // }, {});
        // Object.keys(groupData)
 -->
